import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  makeStyles,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  TablePagination,
} from "@material-ui/core";
import { ESTADO_SOLICITUD_INTEGRACION } from '../../../data/constants';
import { useDispatch } from 'react-redux';
import { startAlerta } from '../../../../../actions/ui/alertas';
import moment from 'moment';
import { AlertFinalizadoStepper } from '../../../../stepper/AlertFinalizadoStepper';
import { anularPeriodoIntegracion, putPeriodosDiscapacidad } from '../../../../../actions/discapacidad/discapacidadActions';

const useStyles = makeStyles({
  cell: {
    paddingLeft: '5%'
  },
});

export const ModalPeriodosSolicitudIntegracion = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [items, setItems] = useState([...props.items]);
  const [periodoSelec, setPeriodoSelec] = useState(null);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);

  useEffect(() => {
    setItems([...props.items]);
  }, [props.items]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePeriodoCantidad = (periodo, cantidad) => {    
    setItems(
      items.map((item) => item.periodo === periodo
        ? {
          ...item,
          cantDias: Number(cantidad),
        }
        : item
      )
    )
  }

  const handleSubmitPeriodos = () => {   
    if (items.filter(s => Number(s.cantDias === 0)).length > 0) {
      return dispatch(startAlerta(`La Cantidad en todos los Periodos debe ser mayor a 0`, 'error', 'Error'));
    }
      
    if (items?.length)
      dispatch(
        putPeriodosDiscapacidad(
          {
            periodos: items.filter(s => !s.fechaAnulacion),
            idSolicitud: props.idSolicitud
          },
          props.closeModalHandler,
        )
      );
  }

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} >
      <DialogTitle>
        Detalle de Periodos - IdSolicitud: {`${props.idSolicitud}`}
      </DialogTitle>
      <DialogContent >
        {Array.isArray(items) &&
          items?.length > 0 ? (
          <TableContainer component={Paper} style={{ overflowX: "auto"}}>
            <Table size={dense ? "small" : "medium"} >
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "30%" }} className={classes.cell}>Periodo</TableCell>
                  <TableCell style={{ width: "30%" }} className={classes.cell}>Cantidad</TableCell>
                  <TableCell style={{ width: "30%" }} className={classes.cell}>Id Comprobante</TableCell>
                  <TableCell style={{ width: "30%" }} className={classes.cell}>Fecha Anulacion</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => {
                    return (
                      <TableRow key={item.periodo}>
                        <TableCell className={classes.cell}>{item.periodo}</TableCell>
                        <TableCell className={classes.cell}>
                          <TextField
                            margin="normal"
                            style={{ maxWidth: 70, minWidth: 70 }}
                            name="item.cantDias"
                            autoComplete="off"
                            value={item.cantDias}
                            disabled={(props.solicitudSeleccionada.idEstadoSolicitud !==
                              ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION
                              && props.solicitudSeleccionada.idEstadoSolicitud !==
                              ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA) || item?.fechaAnulacion
                            }
                            onChange={(e) => {                                
                              if(e.target.value > 0) handleChangePeriodoCantidad(item.periodo, e.target.value);
                            }}
                            type='number'
                            fullWidth
                          />
                        </TableCell>
                        {/* <TableCell className={classes.cell}>{item.cantDias}</TableCell> */}
                        <TableCell className={classes.cell}>{item.idComprobante}</TableCell>
                        <TableCell className={classes.cell}>{item.fechaAnulacion ? moment(item.fechaAnulacion).format("DD/MM/yyyy") : ""}</TableCell>
                        <TableCell>
                          <Button
                            color="primary"
                            disabled={item.fechaAnulacion !== null ? true : false}
                            variant="contained"
                            onClick={() => {
                              setOpenModalConfirm(true)
                              setPeriodoSelec(item.periodo)
                            }}>
                            Anular
                          </Button>
                      </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography style={{ fontStyle: "italic", fontSize: "1.1rem", textAlign: 'center', marginBottom: 15}}>
            No hay periodos generados
          </Typography>
        )}
        {openModalConfirm &&
          <AlertFinalizadoStepper
            open={openModalConfirm}
            pregunta={"Anular Periodo"}
            dialogText={"Está seguro de anular este periodo?"}
            buttonCancel={"No"}
            buttonSubmit={"Si"}
            handleClose={() => { 
              setOpenModalConfirm(false)
              setPeriodoSelec(null)
            }}
            handleSend={() => {
              dispatch(anularPeriodoIntegracion(props.idSolicitud, periodoSelec))
              setOpenModalConfirm(false)
              setPeriodoSelec(null)
            }}
          />
        }
        {items.length > 0 &&
          <Grid item xs={12}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={items.length}
              {...{ rowsPerPage, page }}
              labelRowsPerPage='Registros por página'
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Grid>
        }
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: items?.length > 0 ? "space-between" : "right",
              margin: "1.5rem 0",
            }}
          >
            {items?.length > 0 && (
              <FormControlLabel
                style={{ marginTop: 20 }}
                control={
                  <Switch
                    checked={dense}
                    onChange={(e) => setDense(e.target.checked)}
                  />
                }
                label="Tamaño compacto"
              />
            )}
            <div>
              <Button
                style={{ margin: "0 1rem", marginTop: 20 }}
                color="secondary"
                variant="contained"
                onClick={props.closeModalHandler}
              >
                Cerrar
              </Button>
              {(props.solicitudSeleccionada.idEstadoSolicitud ===
                ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION 
                || props.solicitudSeleccionada.idEstadoSolicitud ===
                ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA) &&
                <Button
                  disabled={props.solicitudSeleccionada.idEstadoSolicitud !==
                    ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION
                    && props.solicitudSeleccionada.idEstadoSolicitud !==
                    ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA
                  }
                  style={{ margin: "0 1rem", marginTop: 20 }}
                  onClick={handleSubmitPeriodos}
                  color="primary"
                  variant="contained"
                >
                  Confirmar
                </Button>
              }
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
